import {ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../services/SwitchBoard";
import {LoadingService} from "../../services/LoadingService";
import {ActivatedRoute, Router} from "@angular/router";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {takeUntil} from "rxjs/operators";
import {forkJoin} from "rxjs";
import {ToastService} from "../../services/Toast.service";
import {StateService} from "../../services/StateService";
import {NumeralService} from "../../services/Numeral.service";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {State} from "../../models/State";
import {ExportService} from "../../services/Export.service";
import {Session} from "../../services/Session";
import {PageTitleService} from "../../services/PageTitle";
import {v4 as uuid} from 'uuid';
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {TrackerPaginatedTableComponent} from "../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {TpiqInputSearchComponent} from "../../input-search/tpiq-input-search/tpiq-input-search.component";
import {ViewTaxStrategyComponent} from "../tax-strategies/view-tax-strategy/view-tax-strategy.component";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {CreateOrUpdateTemplateComponent} from "../templates/create-or-update-template/create-or-update-template.component";
import {ModelBasedNumeral} from "../../directives/model-numeral";
import {TpiqCustomDatepicker} from "../../directives/tpiq-custom-datepicker";
import {FormatAmountPipe} from "../../pipes/format-amount.pipe";
import {FormulaBuilderComponent} from "../client-plan-info/formula-builder/formula-builder.component";
import {CreateOrUpdateClientComponent} from "../clients/create-or-update-client/create-or-update-client.component";
import {CreatePlanComponent} from "../client-plans/create-plan/create-plan.component";
import { TasksService } from "../../services/Tasks.service";
import {FeatureFlagService} from "../../tpiq-services/feature-flag.service";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import { evaluate } from 'mathjs';

declare const _: any;
declare const jQuery: any;

@Component({
  selector: 'app-plan-strategies',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, TpiqSelectDropdownComponent, TrackerPaginatedTableComponent, TpiqInputSearchComponent, ViewTaxStrategyComponent,
  FroalaEditorModule, CreateOrUpdateTemplateComponent, TpiqCustomDatepicker,FormatAmountPipe, FormulaBuilderComponent, CreateOrUpdateClientComponent,
  CreatePlanComponent],
  templateUrl: './plan-strategies.component.html',
  styleUrl: './plan-strategies.component.scss'
})
export class PlanStrategiesComponent {
  org: string = Session.getOrg();
  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @Input() client: any;
  @Input() clientUserId: any;
  @Input() clientTaxPlan: any;
  @Input() clientsList: any;
  @Input() filteredStrategies: any;
  @Input() planYearFilter: any;
  @Input() allStateAssociatedData: any;
  @Input() allAssociatedData: any;
  @Input() allTaxStrategies: any;
  @Input() currentPlan: any;
  @Input() isPaidPlan: any;
  @Input() fixedRatesArray: any;
  @Input() tempCustomTaxRates: any;
  @Output() onStrategyAction: EventEmitter<any> = new EventEmitter<any>();
  tableData: any = {};
  hasStrategies = false;
  strategySort: any = {};
  years: Array<any> = [];
  taxStrategyId: string;
  strategyFilterYear: any;
  /** Strategy catalog including Archived entries, used only to resolve/display existing plan
   *  rows in this table (name lookup + the corrupt-row filter below). The `allTaxStrategies`
   *  @Input stays Active-only and keeps driving the "Add a strategy" picker. */
  private allTaxStrategiesForRowResolution: any[] = [];
  protectedView = false;
  hasGoalDate = false;
  modalSelectedDate: string = '';     
  pendingStrategyLine: any = null;
  reveal: any = {
    addStrategy: false,
    goalDateUpdateForPayPerPlan: false,
    fromulaCalculator: false,
    copyStrategiesToOtherPlan: false,
    createTemplate: false,
    addOrEditClient: false,
    addPlan: false,
    viewStrategyInfo: false
  };
  defaultStrategyId = '';
  defaultStateAssociatedId = '';
  newStrategy: any = {investedAmount: null};
  editMode: boolean;
  currentNotesStrategy: any = {};
  freezPlan = false;
  userReadOnly: any;
  filters: Array<any> = [];
  isMinimized = false;
  showAddCustomRateInPopup: boolean;
  newCustomRate: any = {
    id: '',
    name: '',
    rate: 0,
    formula: {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    }
  };
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ce08f4de-b7f2-449c-9bf8-9674fbf6d0d5', name: 'Qualified Dividends'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'}
  ];
  columns: Array<any> = [
    {name: 'strategyName', title: 'Strategy', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: 'Click strategy name for details'},
    {name: 'strategyType', title: 'Category', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'clientName', title: 'Payor', type: 'badge-input-search', 'status-col': true, classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'relatedPartyType', title: 'Type', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'This can be potential or existing entity types.'},
    {name: 'associated', title: 'Fed Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
    {name: 'stateAssociated', title: 'State Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
    {name: 'amount', title: 'Est. Plan Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Amount that will produce tax savings.'},
    {name: 'investedAmount', title: 'Strategy Investment Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: false, format: '$0,0', skipTab: true, headerColumnDesc: ''},
    {name: 'roiAmount', title: 'Fed Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width', headerclasses:'table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Plan amount multiplied by the associated rate. This field can be overridden as needed.'},
    {name: 'stateRoiAmount', title: 'State Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width', headerclasses:'table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: ''},
    {name: 'sinceYear', title: 'Begin', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'First tax year you are applying strategy to.'},
    {name: 'toYear', title: 'End', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'If the strategy is not indefinite, this is the last tax year it will apply to.'},
    {name: 'goalDate', title: 'Create Task Date', type: 'date', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, allowPastDate: true, initAlways: true, headerColumnDesc: 'The date you are expecting to implement a given strategy. This field is required to create a associated task.'}];
  showActualColumn: boolean = true;
  showDollarChangeColumn: boolean = false;
  showPercentageChangeColumn: boolean = false;
  tempCustomRateObject: any = {
    id : '',
    name : '',
    rate : 0,
    formula: {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    }
  };
  indexOfTempCustomRateObject: any;
  selectedTableRows: Array<any> = [];
  bulkSelectAll = false;
  bulkSelectCount: any;
  bulkUnselected: Array<any> = [];
  strategiesCount = 0;
  @ViewChild('planStrategiesTable') planStrategiesTable;
  actionsData = [{name: 'Copy to Other'}, {name: 'Create a Template'}, {name: 'Delete'}];
  selectedAction: any = null;
  selectedClient: any;
  selectedClientId: any = '';
  selectedPlan: any;
  selectedPlanId: any = '';
  clientPlans: any;
  listOfAllClients: Array<any> = [];
  selectedStrategiesForTemplate: any;
  selectedStrategyIdForView: any;
  originalStrategy: any = {};
  isReorderMode = false;
  reorderedData: any[] | null = null;
  isOrderChanged = false;
  isInvestmentEnabled: boolean = false;
  investmentFormula: any;
  isInvestmentFeature: boolean ;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private titleService: PageTitleService,
    private loadingService: LoadingService,
    private stateService: StateService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService,
    private numeralService: NumeralService,
    private exportService: ExportService,
    private changeDetectorRef: ChangeDetectorRef,
    private tasksService: TasksService,
    private featureFlagService: FeatureFlagService,
    private manageTaxStrategiesServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.isInvestmentFeature = this.featureFlagService.isEnabled('enableInvestmentFeature');
    this.buildFederalAssociatedDataFromPlan();
    const data = this.clientTaxPlan.strategies || [];
    this.taxStrategyId = this.clientTaxPlan.id;
    this.fillYears();
    const hasPositiveActualAmount = data.some(item => item.actualAmount > 0);
    this.showActualAmountColumn(hasPositiveActualAmount);
    this.fetchStrategyCatalogForRowResolution(data);
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data){
        if (toast.data.type == 'strategyLine') {
          this.deleteStrategyLine(toast.data.id);
        } else if (toast.data.type == 'plan-payment') {
          this.payPerPlan(toast.data);
        } else if (toast.data.type == 'strategyBulkDelete') {
          this.bulkDeleteStrategyLines(toast.data.ids);
        }
      }
    });
    this.switchBoard.onClientPlansAdvSearch.pipe(takeUntil(this.destroy$)).subscribe(search => {
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.clientTaxPlan?.firstChange) {
      return; 
    }
    if (changes.clientTaxPlan?.currentValue) {
      this.buildTableData(
        changes.clientTaxPlan.currentValue.strategies || []
      );
    }
}

  fillYears(){
    const startYear: any = _.toNumber(this.planYearFilter);
    const endYear: any = startYear + 10;
    for (let i = startYear - 2; i < endYear; i++){
      this.years.push({id: i, name: i.toString()});
    }
  }

  /** Loads a strategy catalog that includes Archived entries, so archiving a strategy in the
   *  Strategy Library doesn't make this table drop plan rows that still reference it. The
   *  Active-only `allTaxStrategies` @Input is left untouched (still used by the "Add a
   *  strategy" picker, which should not offer archived strategies).
   *  The table is built only once this resolves, so archived-strategy rows render in the
   *  same pass as every other row instead of popping in after the rest of the table. */
  private fetchStrategyCatalogForRowResolution(data: any[]): void {
    this.manageTaxStrategiesServices.getPaginatedTaxStrategies(this.org, this.user.id, {fromIndex: -1}, true, false, 'All')
      .subscribe({
        next: (response) => {
          this.allTaxStrategiesForRowResolution = (response && response.strategies) || [];
          this.buildTableData(data);
        },
        error: () => {
          this.buildTableData(data);
        }
      });
  }

  /** Catalog used to resolve/display existing plan rows: the full-status catalog once loaded,
   *  falling back to the Active-only @Input so rows aren't hidden before it arrives. */
  private rowResolutionCatalog(): any[] {
    return this.allTaxStrategiesForRowResolution.length > 0
      ? this.allTaxStrategiesForRowResolution
      : (Array.isArray(this.allTaxStrategies) ? this.allTaxStrategies : []);
  }

  /** Plan lines that reference a real catalog strategy. Corrupt lines with no strategyId
   *  (strategy_id = NULL) are excluded from display, counts and bulk selection so the
   *  visible rows and the select-all count stay in sync (ticket 868kjbfbb). */
  private visibleStrategies(list: any[]): any[] {
    // When the catalog is loaded, require a matching entry too: getStrategy() returns {} for an
    // unknown id, which would render as an "undefined" row and inflate the count. Fall back to a
    // plain non-empty strategyId while the catalog is still loading so nothing is hidden wrongly.
    const catalog = this.rowResolutionCatalog();
    const hasCatalog = catalog.length > 0;
    return (list || []).filter((s: any) =>
      s && s.strategyId && (!hasCatalog || catalog.some((c: any) => c.id === s.strategyId)));
  }

  buildTableData(data, refreshTable?){
    const base = this;
    this.tableData.options = {
      height: '75vh',
      selectorString: 'id',
      showSearch: false,
      searchString: ''
    };
    this.tableData.columns = [];
    this.tableData.columns = this.formatColumns(this.columns);
    this.tableData.columns.push({name: 'actions', title: '', type: 'html', classes: 'date-column actions-class text-right', sortable: false});
    this.tableData.rows = [];

    let rows = base.tableData.rows || [];
    if (refreshTable){
      rows = [];
    }
    // Corrupt lines with no catalog strategy resolve to an "undefined" row (ticket 868kjbfbb).
    // Compute the visible list ONCE here so rows, strategiesCount and bulk selection stay in sync
    // across every rebuild path (ngOnChanges / formatClientTaxPlanData / updateClientStrategy).
    const visible = base.visibleStrategies(data);
    this.strategiesCount = visible.length;
    visible.forEach((task) => {
      const row = base.createTableRow(task);
      if (row.id){
        rows.push(row);
      }
    });
    if (rows.length > 0 && !this.isReorderMode) {
      rows.push(this.createTotalSavingsRow());
    }
    this.tableData = {...this.tableData, rows};
    this.handleSortOrder(this.strategySort, this.tableData.columns);

    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
    if (refreshTable){
      this.hasStrategies = false;
    }
    setTimeout(() => {
      base.hasStrategies = true;
      base.loadingService.triggerLoadingEvent(false);
      // Restore checkbox states after table rebuild (small delay to ensure DOM is rendered)
      setTimeout(() => {
        base.restoreCheckboxStates();
      }, 10);
    },0);
  }

  formatColumns(columns){
    const base = this;
    const resultArray = [];
    if(!this.isReorderMode){
      resultArray.push({name: 'selectCol', title: `<input type='checkbox' class='global-checkbox'/>`, type: 'html', sortable: false});
    }
    _.each(columns, (column) => {
      if (column.name == 'clientName'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.clientsList, placeholder: column.title, sortable: true, headerColumnDesc: 'This can be potential or existing clients. To make adjustments to your related parties, just go to the Actions icon and select “Related Parties”.'});
      } else if (column.name == 'associated'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, 'conditional-column': true, data: base.allAssociatedData, 'row-condition': 'strategyId', displayKey: 'name', placeholder: column.title, sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'});
      } else if (column.name == 'stateAssociated'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.allStateAssociatedData, displayKey: 'name', placeholder: column.title, sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'});
      } else if (column.name == 'sinceYear'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.years, placeholder: column.title, sortable: true, headerColumnDesc: 'First tax year you are applying strategy to.'});
      } else if (column.name == 'toYear'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.years, placeholder: column.title, sortable: true, headerColumnDesc: 'If the strategy is not indefinite, this is the last tax year it will apply to.'});
      } else if (column.name == 'type'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'normal', sortable: true});
      } else {
        resultArray.push(column);
      }
    });
    return resultArray;
  }

  createTableRow(strategy) {
    const base = this;
    const row: any = {};
    const tooltipClass = base.getTooltipHtmlClass();
    row.selectCol = `<input type='checkbox' class='checkbox'/>`;
    _.each(strategy, (value, key) => {
      if (key == 'strategyName') {
        if (strategy[key]){
          if (strategy.locked){
            row[key] = `<a class='actionOnId' data-action='info'><i class="icon ion-ios-locked-outline" style="color: #F06459; margin-right: 5px;"></i><span>${strategy[key]}</span></a>`;
          } else{
            row[key] = `<a class='actionOnId plan-strategy-name' data-action='info'><span class="text-center badge-tooltip"><span class="paln_details_strategy_name">${strategy[key]}</span><span class="bottomTooltiptext" style="width:160px; padding: 5px;">${strategy[key]}</span></span></a>`;
          }
        }
      } else if (key == 'strategyId') {
        const name = base.getStrategy(strategy).name;
        row[key] = strategy[key];
        row.strategyName = `<a class='actionOnId' data-action='info'><span class='icon badge-tooltip title-name'><div>${name}</div></span></a>`;
      } else if (key == 'clientId'){
        const obj = _.find(base.clientsList, {id: strategy[key]});
        row.clientName = obj ? obj : null;
        row[key] = strategy[key];
      } else if (key == 'associatedWith'){
        const rates = base.getRatesForThisStrategy(strategy);
        const obj = _.find(rates, {id: strategy[key]});
        row.associated = obj ? obj : null;
      } else if (key == 'stateAssociatedWith'){
        const obj = _.find(base.allStateAssociatedData, {id: strategy[key]});
        row.stateAssociated = obj ? obj : null;
      } else if (key == 'sinceYear'){
        const obj = _.find(base.years, {id: strategy[key]});
        row.sinceYear = obj ? obj : null;
      } else if (key == 'toYear'){
        const obj = _.find(base.years, {id: strategy[key]});
        row.toYear = obj ? obj : null;
      } else if (key == 'roiAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        if (strategy.overriden){
          row['roiAmount-class'] = 'column_tool_tip';
          row['roiAmount-value-overridden'] = true;
          row['roiAmount-tooltip-text'] = "Federal tax savings has been overridden.";
        }else{}
      } else if (key == 'stateRoiAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        if (strategy.stateOrverriden){
          row['stateRoiAmount-class'] = 'column_tool_tip';
          row['stateRoiAmount-value-overridden'] = true;
          row['stateRoiAmount-tooltip-text'] = "State tax savings has been overridden";
        }
      } else if (key == 'investedAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        const hasInvestmentFormula = !!strategy.investmentFormula;
        const hasNonZeroPlanAmount = base.numeralService.getNumberValue(strategy.amount) > 0;
        const investedAmountValue = base.numeralService.getNumberValue(strategy[key]);
        const investmentMultiplier = base.parseInvestmentFormula(strategy.investmentFormula);
        const isZeroAgainstFormula = hasInvestmentFormula && hasNonZeroPlanAmount && investmentMultiplier > 0 && investedAmountValue === 0;
        if (strategy.investmentOverriden || isZeroAgainstFormula){
          row['investedAmount-class'] = 'column_tool_tip';
          row['investedAmount-value-overridden'] = true;
          row['investedAmount-tooltip-text'] = 'Investment amount overriden';
        }
      } else if (key == 'dollarDifference'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
      } else if (key == 'percentageDifference'){
        row[key] = strategy[key] + '%';
      } else {
        row[key] = strategy[key];
      }
    });
    row.strategyType = this.getStrategy(strategy).type;
    row.recurring = strategy.recurring;
    row.actions = '';
    let postString = '';
    if (strategy.recurring){
      postString += `<span class='badge-tooltip'><a class='action' data-action='toggle-recurring'><span class="recurring-badge text-center">R</span><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Task is marked recurring</span></a></span>`;
    } else {
      postString += `<span class='badge-tooltip'><a class='action' data-action='toggle-recurring'><span class="non-recurring-badge text-center">R</span></a></span>`;
    }
    if (strategy.taskId){
      postString += `<span class='badge-tooltip'><a class='action' data-action='task'><span class="task-badge text-center">T</span><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Click to go to the associated task</span></a></span>`;
    }
    postString += `<span class='badge-tooltip'><a class='action' data-action='duplicate'><span class="text-center task-badge" style="background-color: #DFCF6A;">D</span><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Click to duplicate</span></a></span>`;
    if (strategy.notes){
      postString += `<span class='badge-tooltip'><a class='action comment-badge' data-action='notes'><i class="material-icons strategy-action-icon mdl-badge last-activity" data-badge=''>short_text</i><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Notes</span></a></span>`;
    } else {
      postString += `<span class='badge-tooltip'><a class='action' data-action='notes'><i class="material-icons strategy-action-icon">short_text</i><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Notes</span></a></span>`;
    }
    postString += `<span class='badge-tooltip'><a class='action' data-action='edit'><i class="material-icons strategy-action-icon">mode_edit</i><span class='bottomTooltiptext tpActionTooltip' style="min-width: 50px !important;max-width: 50px !important;margin-left: -10px;">Edit</span></a></span>`;
    postString += `<span class='badge-tooltip'><a class='action' data-action='delete'><i class="material-icons strategy-action-icon delete">delete</i><span class='bottomTooltiptext tpActionTooltip' style="min-width: 25px !important;margin-left: -22px;top: 115%;">Delete</span></a></span>`;
    row.actions = postString;
    return row;
  }

  getStrategy(strategyLine){
    const strategy = _.find(this.rowResolutionCatalog(), {id: strategyLine.strategyId});
    return strategy ? strategy : {};
  }

  getTooltipHtmlClass(){
    return this.tableData.rows && this.tableData.rows.length == 0 ? 'bottomTooltiptext' : 'topTooltiptext';
  }

  getRatesForThisStrategy(strategy){
    return this.allAssociatedData[strategy.strategyId] ? this.allAssociatedData[strategy.strategyId] : [];
  }

  createTotalSavingsRow(isFreezedPlan?) {
    const cols: any = _.cloneDeep(this.columns);
    const row: any = {};
    const base = this;
    _.each(cols, (column) => {
      column.type = 'html';
      if (column.name == 'strategyName'){
        if (isFreezedPlan) {
          row[column.name] = `Total`;
        } else {
          row[column.name] = `<span style='color: #14B5F0'>Total</span>`;
        }
      } else if (column.name == 'amount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', (base.clientTaxPlan.totalPlanAmount || 0));
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', (base.clientTaxPlan.totalPlanAmount || 0)) + `</span>`;
        }
      } else if (column.name == 'actualAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', (base.clientTaxPlan.actualTaxSavingsTotal || 0));
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', (base.clientTaxPlan.actualTaxSavingsTotal || 0)) + `</span>`;
        }
      } else if (column.name == 'dollarDifference'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', (base.clientTaxPlan.totalDollarDifference || 0));
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', (base.clientTaxPlan.totalDollarDifference || 0)) + `</span>`;
        }
      } else if (column.name == 'percentageDifference'){
        if (isFreezedPlan) {
          row[column.name] = base.clientTaxPlan.totalPercentageDifference + '%';
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.clientTaxPlan.totalPercentageDifference + `%</span>`;
        }
      } else if (column.name == 'roiAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', base.clientTaxPlan.totalAmount);
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', base.clientTaxPlan.totalAmount) + `</span>`;
        }
      } else if (column.name == 'stateRoiAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', base.clientTaxPlan.totalStateTaxSavings);
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', base.clientTaxPlan.totalStateTaxSavings) + `</span>`;
        }
      }else if (column.name == 'investedAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', base.clientTaxPlan.totalInvestedAmount);
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', base.clientTaxPlan.totalInvestedAmount) + `</span>`;
        }
      } else {
        row[column.name] = '';
      }
    });
    row.isTotalRow = true;
    return row;
  }

  handleSortOrder(tasksSortOrder, columns) {
    _.each(columns, (column) => {
      column.sortType = tasksSortOrder[column.name];
    });
  }

  handleStrategyTableAction($event) {
    const action = $event.action;
    if (action == 'task') {
      this.showTaskSinglePage($event);
    } else if (action == 'info'){
      this.showStrategy($event);
    } else if (action == 'notes'){
      this.showStrategyNotesPopup($event);
    } else if (action == 'delete'){
      this.showDeleteStrategyPopup($event.id);
    } else if (action == 'edit'){
      this.editStrategy($event);
    } else if (action == 'toggle-recurring') {
      this.toggleRecurringForStrategyLine($event);
    } else if (action == 'duplicate') {
      this.duplicateStrategy($event);
    }
  }

  showTaskSinglePage(strategyRow) {
    const strategy = _.find(this.clientTaxPlan.strategies, {strategyId: strategyRow.strategyId});
    if (strategy && strategy.locked){
      this.showPurchaseMessage();
    } else if (strategyRow.taskId){
      const url = this._router.url.split('?')[0];
      this.stateService.addState(new State('TAX_STRATEGY', url, null, null, null));
      this._router.navigate(['clients', this.clientTaxPlan.clientId, 'task', strategyRow.taskId, 'singlePage']);
    }
  }

  showStrategy(strategy) {
    const strategyData = _.find(this.clientTaxPlan.strategies, {strategyId: strategy.strategyId});
    if (strategyData && !strategyData.locked){
      this.reveal.viewStrategyInfo = true;
      this.selectedStrategyIdForView = strategy.strategyId;
    } else if (strategyData && strategyData.locked){
      this.showPurchaseMessage();
    }
  }

  showPurchaseMessage(){
    this.toastService.pop(TOAST_TYPE.info, 'To see more attorney client collaborated strategies, please purchase the full version of the software');
  }

  showStrategyNotesPopup($event){
    this.reveal.strategyNotes = true;
    const strategy = _.find(this.allTaxStrategies, {id: $event.strategyId});
    this.currentNotesStrategy = {
      id: $event.id,
      strategyName: strategy.name,
      notes: $event.notes,
      reportCustomText: $event.reportCustomText
    };
  }

  showDeleteStrategyPopup(strategyLineId){
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', {
      id: strategyLineId,
      type: 'strategyLine'
    });
  }

  editStrategy($event){
    const strategyLine = _.find(this.clientTaxPlan.strategies, {id: $event.id});
    if (strategyLine){
      if(strategyLine.investedAmount == 0){
        strategyLine.investedAmount = strategyLine.amount * this.parseInvestmentFormula(strategyLine.investmentFormula);
      }
      this.defaultStrategyId = strategyLine.associatedWith;
      this.defaultStateAssociatedId = strategyLine.stateAssociatedWith;
      this.originalStrategy = _.cloneDeep(strategyLine);
      this.newStrategy = strategyLine;
      this.editMode = true;
      this.reveal.addStrategy = true;
    }
  }

  toggleRecurringForStrategyLine($event){
    const strategyLine = {
      id: $event.id,
      associatedWith: ($event.associated) ? $event.associated.id : null,
      overriden: ($event.overriden) ? $event.overriden : false,
      stateAssociatedWith: $event.stateAssociated ? $event.stateAssociated.id : null,
      stateOrverriden: ($event.stateOrverriden) ? $event.stateOrverriden : false,
      amount: $event.amount,
      actualAmount: $event.actualAmount,
      roiAmount: $event.roiAmount,
      stateRoiAmount: $event.stateRoiAmount,
      clientId: $event.clientId,
      goalDate: $event.goalDate,
      executionDate: $event.executionDate,
      strategyId: $event.strategyId,
      sinceYear: $event.sinceYear ? $event.sinceYear.id : 0,
      toYear: $event.toYear ? $event.toYear.id : 0,
      recurring: !$event.recurring,
      taskId: $event.taskId,
      parentClientId: this.clientUserId,
      notes: $event.notes,
      investmentOverriden: ($event.investmentOverriden) ? $event.investmentOverriden : false
    };
    this.updateStrategyLine(strategyLine);
  }

  sortByColumn($event){
    this.strategySort[$event.column] = $event.order;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, this.strategyFilterYear, $event.column, $event.order, this.protectedView)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.clientTaxPlan = response;
          this.buildTableData(response.strategies || [], true);
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to sort.');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  optionSelected($event){
    const base = this;
    const strategyLine: any = {
      id: $event.row.id,
      associatedWith: $event.row.associated ? $event.row.associated.id : null,
      overriden: ($event.row.overriden) ? $event.row.overriden : false,
      stateAssociatedWith: $event.row.stateAssociated ? $event.row.stateAssociated.id : null,
      stateOrverriden: ($event.row.stateOrverriden) ? $event.row.stateOrverriden : false,
      amount: $event.row.amount,
      actualAmount: $event.row.actualAmount,
      roiAmount: $event.row.roiAmount,
      stateRoiAmount: $event.row.stateRoiAmount,
      clientId: $event.row.clientId,
      investedAmount: $event.row.investedAmount,
      goalDate: $event.row.goalDate,
      executionDate: $event.row.executionDate,
      strategyId: $event.row.strategyId,
      sinceYear: $event.row.sinceYear ? $event.row.sinceYear.id : 0,
      toYear: $event.row.toYear ? $event.row.toYear.id : 0,
      recurring: $event.row.recurring,
      taskId: $event.row.taskId,
      parentClientId: this.clientUserId,
      notes: $event.row.notes,
      investmentOverriden: ($event.row.investmentOverriden) ? $event.row.investmentOverriden : false
    };
    if ($event.column == 'associated'){
      strategyLine.associatedWith = $event.entry.id;
      this.calculateResultAmount(strategyLine);
    } else if ($event.column == 'stateAssociated') {
      strategyLine.stateAssociatedWith = $event.entry.id;
      this.calculateStateResultAmount(strategyLine);
    } else if ($event.column == 'clientName'){
      strategyLine.clientId = $event.entry.id;
      strategyLine.relatedPartyName = $event.entry.name;
    } else if ($event.column == 'sinceYear'){
      strategyLine.sinceYear = $event.entry.id;
    } else if ($event.column == 'toYear'){
      if ($event.entry.id < strategyLine.sinceYear){
        this.toastService.pop(TOAST_TYPE.error, 'You can\'t have the end year before the start year');
        const rows = this.tableData.rows || [];
        _.each(rows, (row) => {
          if (row.id == $event.row.id){
            const oldStrategyLine = _.find(base.clientTaxPlan.strategies, {id: $event.row.id});
            const obj = _.find(base.years, {id: oldStrategyLine.toYear});
            row.toYear = obj ? obj : null;
          }
        });
        this.tableData = {...this.tableData, rows};
        return;
      } else{
        strategyLine.toYear = $event.entry.id;
      }
    }
    this.setRelatedPartyName(strategyLine);
    this.updateStrategyLine(strategyLine);
  }

  setRelatedPartyName(strategyLine){
    const relatedParty = _.find(this.client.relatedParties, {id: strategyLine.clientId});
    strategyLine.relatedPartyName = relatedParty ? relatedParty.name : '';
  }

  updateStrategyLine(strategyLine){
    this.loadingService.triggerLoadingEvent(true);
    strategyLine.roiAmount = this.numeralService.getNumberValue(strategyLine.roiAmount);
    strategyLine.stateRoiAmount = this.numeralService.getNumberValue(strategyLine.stateRoiAmount);
    strategyLine.investedAmount = this.numeralService.getNumberValue(strategyLine.investedAmount);
    strategyLine.action = 'update';
    this.taxPlanningService.addUpdateTaxStrategyLine(this.org, this.user.id, this.taxStrategyId, strategyLine)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.getClientTaxPlanWithNewData();
        const rows = this.tableData.rows || [];
        const updatedRow = this.createTableRow(response);
        const rowIndex = _.findIndex(rows, {id: strategyLine.id});
        rows[rowIndex] = updatedRow;
        const strategyIndex = _.findIndex(this.clientTaxPlan.strategies, {id: strategyLine.id});
        this.clientTaxPlan.strategies[strategyIndex] = response;
        //this.tableData = {...this.tableData, rows};
        this.toastService.pop(TOAST_TYPE.success, 'Strategy updated successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to update strategy');
      });    
  }

  getClientTaxPlanWithNewData(callback?: (plan: any) => void){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, null, null, null, this.protectedView)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          // Replace the whole plan so strategies are in sync
          Object.assign(this.clientTaxPlan, response);
          this.strategySort = {};
          this.buildTableData(this.clientTaxPlan.strategies || []);
          // Execute callback if provided
          if (callback) {
            callback(this.clientTaxPlan);
          }
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to load tax plan');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  calculateResultAmount(strategy, isStateRateCalcReq?){
    const associatedWithId = strategy.associatedWith;
    if (associatedWithId){
      const multiplierRate = this.getRate(strategy, associatedWithId);
      if (strategy.actualAmount) {
        strategy.roiAmount = Math.ceil(multiplierRate * strategy.actualAmount);
      } else {
        strategy.roiAmount = Math.ceil(multiplierRate * strategy.amount);
      }
      strategy.overriden = false;
    } else {
      strategy.roiAmount = (strategy.actualAmount) ? strategy.actualAmount : strategy.amount;
    }
    if (isStateRateCalcReq) {
      this.calculateStateResultAmount(strategy);
    }
  }

  calculateStateResultAmount(strategy){
    const stateAssociatedWithId = strategy.stateAssociatedWith;
    if (stateAssociatedWithId){
      const multiplierRate = this.getStateRate(strategy, stateAssociatedWithId);
      strategy.stateRoiAmount = multiplierRate * ((strategy.actualAmount) ? strategy.actualAmount : strategy.amount);
      strategy.stateOrverriden = false;
    } else {
      strategy.stateRoiAmount = 0;
    }
  }

  getRate(strategy, associatedWithId){
    let rates = this.allAssociatedData[strategy.strategyId] || [];
    if (rates.length == 0){
      rates = this.associatedWith;
    }
    const obj = _.find(rates, {id: associatedWithId});
    if (obj){
      if (obj.name == 'Effective Rate'){
        return this.clientTaxPlan.effectiveRate / 100;
      } else if (obj.name == 'Marginal Rate'){
        return this.clientTaxPlan.marginalRate / 100;
      } else if (obj.name == 'Cap Gain Rate'){
        return this.clientTaxPlan.capGainRate / 100;
      } else if (obj.name == 'C Corp Flat Rate'){
        return this.clientTaxPlan.ccropFlatRate / 100;
      } else if (obj.name == 'Market Growth Rate'){
        return (this.clientTaxPlan.marketGrowthRate || 5) / 100;
      } else if (obj.name == 'SE Tax Rate'){
        return (this.clientTaxPlan.seTaxRate || 15.3) / 100;
      } else if (obj.name == 'Full Credit'){
        // Here Full Credit means 100% credit i.e 100/100
        return 1;
      } else if (obj.name == 'N/A'){
        return 0;
      } else if (obj.formula && obj.formula.actualValuesArray && obj.formula.actualValuesArray.length > 0) {
        const fromula = (_.isString(obj.formula)) ? JSON.parse(obj.formula) : obj.formula;
        let calcVal = '';
        if (fromula.displayValuesArray && fromula.displayValuesArray.length > 0) {
          _.each(fromula.displayValuesArray, (value) => {
            if (value == 'Effective Rate') {
              calcVal += this.clientTaxPlan.effectiveRate;
            } else if (value == 'Marginal Rate'){
              calcVal += this.clientTaxPlan.marginalRate;
            } else if (value == 'Cap Gain Rate'){
              calcVal += this.clientTaxPlan.capGainRate;
            } else if (value == 'C Corp Flat Rate'){
              calcVal += this.clientTaxPlan.ccropFlatRate;
            } else if (value == 'Market Growth Rate'){
              calcVal += this.clientTaxPlan.marketGrowthRate || 5;
            } else if (value == 'SE Tax Rate'){
              calcVal += this.clientTaxPlan.seTaxRate || 15.3;
            } else {
              calcVal += value;
            }
          });
        }
        const result = calcVal ? evaluate(calcVal) : 0;
        return result ? (result / 100) : 1;
      }  else {
        return obj.rate / 100;
      }
    } else {
      return 0;
    }
  }

  getStateRate(strategy, stateAssociatedWithId){
    if (this.allStateAssociatedData && this.allStateAssociatedData.length > 0) {
      const obj = _.find(this.allStateAssociatedData, {id: stateAssociatedWithId});
      if (obj){
        let stateRate: any;
        if (obj.name === 'Full Credit') {
          // Here Full Credit means 100% credit i.e 100/100
          stateRate = 1;
        } else if (obj.name === 'N/A') {
          stateRate = 0;
        } else {
          stateRate = obj.rate / 100;
        }
        return stateRate;
      } else {
        return 0;
      }
    }
  }

  updateInput($event){
    const strategyLine: any = {
      id: $event.row.id,
      associatedWith: $event.row.associated ? $event.row.associated.id : null,
      stateAssociatedWith: $event.row.stateAssociated ? $event.row.stateAssociated.id : null,
      amount: $event.row.amount,
      actualAmount: $event.row.actualAmount,
      roiAmount: $event.row.roiAmount,
      stateRoiAmount: $event.row.stateRoiAmount,
      investedAmount: $event.row.investedAmount,
      clientId: $event.row.clientId,
      goalDate: $event.row.goalDate,
      executionDate: $event.row.executionDate,
      strategyId: $event.row.strategyId,
      sinceYear: $event.row.sinceYear ? $event.row.sinceYear.id : '',
      toYear: $event.row.toYear ? $event.row.toYear.id : '',
      recurring: $event.row.recurring,
      parentClientId: this.clientUserId,
      taskId: $event.row.taskId,
      notes: $event.row.notes,
      investmentFormula: $event.row.investmentFormula,
      overriden: ($event.row.overriden) ? $event.row.overriden : false,
      stateOrverriden: ($event.row.stateOrverriden) ? $event.row.stateOrverriden : false,
      investmentOverriden: ($event.row.investmentOverriden) ? $event.row.investmentOverriden : false,
    };
    if ($event.column == 'amount'){
      const lineObj = _.find(this.clientTaxPlan.strategies, {id: strategyLine.id});
      if (lineObj.amount != $event.row.amount){
        lineObj.amount = $event.row.amount;
        this.calculateResultAmount(strategyLine);
        this.calculateStateResultAmount(strategyLine);
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
      }
    } else if ($event.column == 'actualAmount') {
      const lineObj = _.find(this.clientTaxPlan.strategies, {id: strategyLine.id});
      if (lineObj.actualAmount != $event.row.actualAmount){
        lineObj.actualAmount = $event.row.actualAmount;
        const hasPositiveActualAmount = this.clientTaxPlan.strategies.some(item => item.actualAmount > 0);
        this.showActualAmountColumn(hasPositiveActualAmount);
        this.calculateResultAmount(strategyLine);
        this.calculateStateResultAmount(strategyLine);
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
      }
    } else if ($event.column == 'roiAmount'){
      const lineObj = _.find(this.clientTaxPlan.strategies, {id: strategyLine.id});
      if($event.row.resetValue){
        this.calculateResultAmount(strategyLine);
        strategyLine.overriden = false;
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
        return
      }
      if (lineObj.roiAmount != $event.row.roiAmount){
        lineObj.roiAmount = $event.row.roiAmount;
        strategyLine.overriden = true;
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
      }
    } else if ($event.column == 'stateRoiAmount'){
      const lineObj = _.find(this.clientTaxPlan.strategies, {id: strategyLine.id});
       if($event.row.resetValue){
        this.calculateStateResultAmount(strategyLine);
        strategyLine.overriden = false;
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
        return
      }
      if (lineObj.stateRoiAmount != $event.row.stateRoiAmount){
        lineObj.stateRoiAmount = $event.row.stateRoiAmount;
        strategyLine.stateOrverriden = true;
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
      }
    } else if ($event.column == 'investedAmount') {
      if ($event.row.resetValue) {
        strategyLine.investedAmount = Math.ceil(
          this.numeralService.getNumberValue(strategyLine.amount) * this.parseInvestmentFormula(strategyLine.investmentFormula)
        );
        strategyLine.investmentOverriden = false;
        $event.row.resetValue = false;
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
        return;
      }
      const lineObj = _.find(this.clientTaxPlan.strategies, {id: strategyLine.id});
      if (lineObj.investedAmount != $event.row.investedAmount){
        lineObj.investedAmount = $event.row.investedAmount;
        strategyLine.investmentOverriden = true;
        this.setRelatedPartyName(strategyLine);
        this.updateStrategyLine(strategyLine);
      }
    } else if ($event.column == 'goalDate') {
      if (this.currentPlan.includes("Pay-Per-Tax-Plan") && !this.isPaidPlan) {
        $event.row.goalDate = '';
        this.reveal.goalDateUpdateForPayPerPlan = true;
      } else {
        if($event.row.goalDate == ''){
          this.hasGoalDate = true;
          this.modalSelectedDate = '';
          this.pendingStrategyLine = strategyLine;   
        }else{
          this.setRelatedPartyName(strategyLine);
          this.updateStrategyLine(strategyLine);
        }
      }
    } else {
      this.setRelatedPartyName(strategyLine);
      this.updateStrategyLine(strategyLine);
    }
  }

  hideReveal(key, overrideMinimizeStatus?){
    if (key == 'copyStrategiesToOtherPlan') {
      this.selectedClient = '';
      this.selectedClientId = '';
      this.selectedPlan = '';
      this.selectedPlanId = '';
    }
    this.reveal[key] = false;
    this.showAddCustomRateInPopup = false;
    if (key === 'addStrategy' && this.editMode) {
    const index = this.clientTaxPlan.strategies.findIndex(
    s => s.id === this.originalStrategy.id
    );
    
    if (index !== -1) {
      this.clientTaxPlan.strategies[index] = _.cloneDeep(this.originalStrategy);
    }
    }
  }

  confirm(){
    this.reveal.goalDateUpdateForPayPerPlan = false;
    this.toastService.pop(TOAST_TYPE.confirm, "Please confirm purchase of this client's plan (nonrefundable).", {
      id: this.taxStrategyId,
      type: 'plan-payment'
    });
  }

  payPerPlan(data) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.payPerPlanInfo(this.org, this.user.id, this.taxStrategyId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const paidPlans = this.taxPlanningService.getPaidPlans();
        paidPlans.push(this.taxStrategyId);
        this.taxPlanningService.setPaidPlans(paidPlans);
        this.isPaidPlan = true;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to perform operation');
      });
  }

  deleteStrategyLine(strategyLineId: string) {
    this.loadingService.triggerLoadingEvent(true);
  
    this.taxPlanningService
      .deleteTaxStrategyLine(this.org, this.user.id, this.taxStrategyId, strategyLineId)
      .subscribe({
        next: () => {
          this.toastService.pop(TOAST_TYPE.success, 'Strategy deleted successfully');
  
          // 🔹 keep local plan in sync
          const strategyIndex = _.findIndex(this.clientTaxPlan.strategies, { id: strategyLineId });
          if (strategyIndex > -1) {
            this.clientTaxPlan.strategies.splice(strategyIndex, 1);
          }
  
          // 🔹 keep the “Actual / $ Change / % Change” logic intact
          const hasPositiveActualAmount = this.clientTaxPlan.strategies.some(
            (item: any) => item.actualAmount > 0
          );
          this.showActualAmountColumn(hasPositiveActualAmount);
  
          // Immediate UI update (row removal). Totals come from clientTaxPlan totals and will be
          // refreshed from the backend right after the delete completes.
          this.buildTableData(this.clientTaxPlan.strategies || []);

          // 🔹 Refresh the full plan AFTER delete completes to ensure totals are recalculated
          this.getClientTaxPlanWithNewData((plan) => {
            this.onStrategyAction.emit({
              type: 'strategy-deleted',
              plan
            });
          });
        },
        error: () => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to delete strategy');
        }
      });
  }

  getClientTaxPlan(year?){
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, year, null, null, this.protectedView)
      .subscribe({
        next: (response) => {
          this.formatClientTaxPlanData(response);
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to load tax plan');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  formatClientTaxPlanData(data) {
    this.clientTaxPlan = data;
    this.buildTableData(data.strategies || []);
  }

  updateNotesForStrategy(){
    const strategyLine = _.find(this.clientTaxPlan.strategies, {id: this.currentNotesStrategy.id});
    strategyLine.notes = this.currentNotesStrategy.notes;
    strategyLine.reportCustomText = this.currentNotesStrategy.reportCustomText.replace(/<\/?p[^>]*>/g, '').trim();
    this.updateClientStrategy();
    this.reveal.strategyNotes = false;
  }

  updateClientStrategy(){
    this.loadingService.triggerLoadingEvent(true);
    if (this.clientTaxPlan.files) {
      this.clientTaxPlan.files = (this.clientTaxPlan.files && this.clientTaxPlan.files.length > 0) ? JSON.stringify(this.clientTaxPlan.files) : '';
    }
    this.stringifyCustomRateFormulas();
    this.taxPlanningService.updateTaxPlanForClient(this.org, this.user.id, this.clientTaxPlan.id, this.clientTaxPlan)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Tax Plan Updated Successfully');
          this.onStrategyAction.emit();
          this.clientTaxPlan = response;
          this.buildTableData(this.clientTaxPlan.strategies || []);
        }, error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try{
            const errorObj = JSON.parse(error);
            this.toastService.pop(TOAST_TYPE.error, errorObj.message);
          } catch (err){
            this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Tax Plan');
          }
        }
      });
  }

  stringifyCustomRateFormulas(){
    _.each(this.clientTaxPlan.customTaxRates, (customTaxRate) => {
      try{
        if (!_.isString(customTaxRate.formula)) {
          customTaxRate.formula = JSON.stringify(customTaxRate.formula);
        }
      } catch (e){}
    });
  }

  addNewStrategy() {
    if (this.isMinimized){
      this.isMinimized = false;
      this.reveal.addStrategy = true;
    } else {
      this.editMode = false;
      this.newStrategy = {};
      this.filteredStrategies = _.cloneDeep(this.allTaxStrategies);
      this.reveal.addStrategy = true;
    }
  }

  /**
   * Opens the plan in RAP (Review and Planning) edit mode
   * Triggers the sandboxed editing experience for the current plan
   */
  openPlanInRAPMode() {
    if (!this.clientTaxPlan || !this.clientTaxPlan.id) {
      console.error('No plan available to open in RAP mode');
      return;
    }

    // Emit event to parent component with RAP mode parameters
    this.onStrategyAction.emit({
      action: 'OPEN_IN_RAP',
      planId: this.clientTaxPlan.id,
      clientId: this.client?.id,
      planName: this.clientTaxPlan.name
    });
  }

  minimizeReveal(key){
    this.isMinimized = true;
    this.reveal[key] = false;
  }

  setClient($event){
    this.newStrategy.clientId = $event.id;
    const client = _.find(this.clientsList, {id: $event.id});
    if (client && client.type == 'Other'){
      this.filteredStrategies = _.cloneDeep(this.allTaxStrategies);
    } else if (client && client.type == '1040'){
      this.filteredStrategies = _.filter(this.allTaxStrategies, (strategy) => {
        return strategy.applicableTo == 'Individual' || strategy.applicableTo == 'Both';
      });
    } else if (client && client.type != '1040'){
      this.filteredStrategies = _.filter(this.allTaxStrategies, (strategy) => {
        return strategy.applicableTo == 'Business' || strategy.applicableTo == 'Both';
      });
    }
  }

  setStrategy($event){
    this.newStrategy.strategyId = $event.id;
    this.newStrategy.locked = $event.locked;
    if ($event.associatedWith){
      this.newStrategy.associatedWith = $event.associatedWith;
      this.defaultStrategyId = $event.associatedWith;
    } else {
      this.defaultStrategyId = '';
    }
    if($event.stateAssociatedWith){
      const obj = this.getStateAssociated($event.stateAssociatedWith);
          if (obj) {
            this.newStrategy.stateAssociatedWith = obj.id;
            this.defaultStateAssociatedId = obj.id;
          }
    }

    this.newStrategy.recurring = $event.recurring == 'Yearly';
    //const strategy = this.allTaxStrategies.find(s => s.id === $event.id);
    this.newStrategy.isInvestmentEnabled = $event.investmentEnabled?? false;
    this.newStrategy.investmentFormula = $event.investmentFormula ?? 0;
   

    this.calculateResultAmount(this.newStrategy);
  }

  toggleAddCustomRate(flag){
    this.showAddCustomRateInPopup = flag;
  }

  appendNewCustomRate(){
    if (this.newCustomRate.name && this.newCustomRate.rate){
      this.newCustomRate.id = uuid();
      this.newCustomRate.formula =  JSON.stringify(this.newCustomRate.formula);
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.addEditCustomRate(Session.getOrg(), this.user.id, this.clientTaxPlan.id, this.newCustomRate).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.newCustomRate.formula =  JSON.parse(this.newCustomRate.formula);
        this.toastService.pop(TOAST_TYPE.success, 'Custom Rate created successfully');
        this.clientTaxPlan.customTaxRates.push(this.newCustomRate);
        // Only expose non-state custom rates to the Federal Associated dropdown
        const parsedCustomRate = _.cloneDeep(this.newCustomRate);
        const parsedFormula = this.safeParseFormula(parsedCustomRate.formula);
        const isStateRate = parsedFormula && parsedFormula.type && (parsedFormula.type === 'individual' || parsedFormula.type === 'corporate');
        parsedCustomRate.formula = parsedFormula;
        if (!isStateRate) {
          this.associatedWith = [...this.associatedWith, parsedCustomRate];
          if (this.newStrategy && this.newStrategy.strategyId) {
            const strategyRates = this.allAssociatedData[this.newStrategy.strategyId] || [];
            const strategyRateIndex = _.findIndex(strategyRates, {id: parsedCustomRate.id});
            if (strategyRateIndex === -1) {
              this.allAssociatedData[this.newStrategy.strategyId] = [...strategyRates, parsedCustomRate];
            } else {
              strategyRates[strategyRateIndex] = parsedCustomRate;
              this.allAssociatedData[this.newStrategy.strategyId] = [...strategyRates];
            }
          }
        }
        // Ensure state dropdown still gets it if it is a state rate
        this.buildStateAssociatedDataFromPlan();
        this.newStrategy.associatedWith = this.newCustomRate.id;
        this.newCustomRate = {
          id: '',
          name: '',
          rate: 0,
          formula: {
            displayValue: '',
            actualValue: '',
            displayValuesArray: [],
            actualValuesArray: []
          }
        };
        this.showAddCustomRateInPopup = false;
        this.buildAssociatedObject();
        this.calculateResultAmount(this.newStrategy);
        this.defaultStrategyId = response.id;
        this.tableData = {...this.tableData};
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : 'Failed to create Custom Rate';
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
    } else if (!this.newCustomRate.name) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter name');
    } else if (!this.newCustomRate.rate) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter rate');
    }
  }

  buildAssociatedObject(){
    const base = this;
    this.associatedWith = [...this.associatedWith];
    _.each(this.allTaxStrategies, (obj) => {
      let strategyRates = [...base.associatedWith];
      if (obj.customTaxRates){
        const filteredCustomRates = _.chain(obj.customTaxRates)
          .map((customTaxRate) => {
            const parsedRate = _.cloneDeep(customTaxRate);
            try{
              parsedRate.formula = base.safeParseFormula(parsedRate.formula);
            } catch (e){
              console.error('Failed to parse formula : ', e);
            }
            return parsedRate;
          })
          .filter((customTaxRate) => !base.isStateRate(customTaxRate))
          .value();
        strategyRates = strategyRates.concat(filteredCustomRates);
      }
      base.allAssociatedData[obj.id] = strategyRates;
    });
  }

  private safeParseFormula(formula: any) {
    if (formula === undefined || formula === null) {
      return formula;
    }
    if (typeof formula === 'string') {
      try {
        return JSON.parse(formula);
      } catch (e) {
        return formula;
      }
    }
    return formula;
  }

  private isStateRate(customRate: any) {
    const rateType = customRate && customRate.formula && customRate.formula.type;
    return rateType === 'individual' || rateType === 'corporate';
  }

  private buildStateAssociatedDataFromPlan() {
    const data: any[] = [];
    if (this.clientTaxPlan && this.clientTaxPlan.customTaxRates && this.clientTaxPlan.customTaxRates.length > 0) {
      _.each(this.clientTaxPlan.customTaxRates, (customRate) => {
        const parsedRate = _.cloneDeep(customRate);
        parsedRate.formula = this.safeParseFormula(parsedRate.formula);
        if (this.isStateRate(parsedRate)) {
          data.push(parsedRate);
        }
      });
    }
    data.push({id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'});
    this.allStateAssociatedData = data;
  }

  private buildFederalAssociatedDataFromPlan() {
    const rates = [...this.associatedWith];
    if (this.clientTaxPlan && this.clientTaxPlan.customTaxRates && this.clientTaxPlan.customTaxRates.length > 0) {
      _.each(this.clientTaxPlan.customTaxRates, (customRate) => {
        const parsedRate = _.cloneDeep(customRate);
        parsedRate.formula = this.safeParseFormula(parsedRate.formula);
        if (!this.isStateRate(parsedRate)) {
          const rateIndex = _.findIndex(rates, {id: parsedRate.id});
          if (rateIndex === -1) {
            rates.push(parsedRate);
          } else {
            rates[rateIndex] = parsedRate;
          }
        }
      });
    }
    this.associatedWith = [...rates];
  }

  setAssociatedWith($event, type){
    if (type == 'federal') {
      this.newStrategy.associatedWith = $event.id;
      this.calculateResultAmount(this.newStrategy);
    } else if (type == 'state') {
      this.newStrategy.stateAssociatedWith = $event.id;
      this.calculateStateResultAmount(this.newStrategy);
    }
  }

  updateGoalDate($event, strategy){
    if (this.currentPlan.includes("Pay-Per-Tax-Plan") && !this.isPaidPlan) {
      this.reveal.goalDateUpdateForPayPerPlan = true;
      this.editMode = false;
      this.isMinimized = true;
      this.reveal.addStrategy = false;
    } else if ($event){
      strategy.goalDate = $event;
    }
  }

  selectYear($event, key){
    this.newStrategy[key] = $event.entry.id;
  }

  saveNewStrategy(){
    if (this.newStrategy.strategyId && this.newStrategy.clientId && this.newStrategy.sinceYear){
      this.newStrategy.sinceYear = (typeof this.newStrategy.sinceYear === 'string') ? this.newStrategy.sinceYear.trim() : this.newStrategy.sinceYear;
      this.newStrategy.toYear = (typeof this.newStrategy.toYear === 'string') ? this.newStrategy.toYear.trim() : this.newStrategy.toYear;
      if (isNaN(this.newStrategy.sinceYear) || (this.newStrategy.toYear && isNaN(this.newStrategy.toYear))) {
        this.toastService.pop(TOAST_TYPE.error, 'Year should be in YYYY format');
      } else if (!_.inRange(this.newStrategy.sinceYear, 2000, 2099) || (this.newStrategy.toYear && !_.inRange(this.newStrategy.toYear, 2000, 2099))) {
        this.toastService.pop(TOAST_TYPE.error, 'Year should be in YYYY format');
      } else if (this.newStrategy.toYear && parseInt(this.newStrategy.toYear) < parseInt(this.newStrategy.sinceYear)) {
        this.toastService.pop(TOAST_TYPE.error, 'End Year cannot be earlier than Start Year');
      }else {
        this.newStrategy.action = this.editMode ? 'update' : 'create';
        this.newStrategy.parentClientId = this.clientUserId;
        this.setRelatedPartyName(this.newStrategy);
        this.loadingService.triggerLoadingEvent(true);
        this.taxPlanningService.addUpdateTaxStrategyLine(this.org, this.user.id, this.taxStrategyId, this.newStrategy)
          .subscribe({
            next: (response) => {
              const successMessage = (this.editMode) ? 'Strategy updated successfully' : 'Strategy created successfully';
              this.toastService.pop(TOAST_TYPE.success, successMessage);
              this.newStrategy = {};
              this.reveal.addStrategy = false;
              if (this.editMode) {
                const strategyIndex = _.findIndex(this.clientTaxPlan.strategies, {id: response.id});
                this.clientTaxPlan.strategies[strategyIndex] = response;
                // Update local state immediately
                const hasPositiveActualAmount = this.clientTaxPlan.strategies.some(item => item.actualAmount > 0);
                this.showActualAmountColumn(hasPositiveActualAmount);
                this.buildTableData(this.clientTaxPlan.strategies || []);
                // Refresh from backend and emit updated plan when complete
                this.getClientTaxPlanWithNewData((plan) => {
                  this.onStrategyAction.emit({
                    type: 'strategy-updated',
                    plan: plan
                  });
                });
              } else {
                // Update local state immediately
                this.clientTaxPlan.strategies.push(response);
                const hasPositiveActualAmount = this.clientTaxPlan.strategies.some(item => item.actualAmount > 0);
                this.showActualAmountColumn(hasPositiveActualAmount);
                this.buildTableData(this.clientTaxPlan.strategies || []);
                // Refresh from backend and emit updated plan when complete
                this.getClientTaxPlanWithNewData((plan) => {
                  this.onStrategyAction.emit({
                    type: 'strategy-added',
                    plan: plan
                  });
                });
              }
            }, error: (error) => {
              this.loadingService.triggerLoadingEvent(false);
              const failedMessage = (this.editMode) ? 'Failed to update strategy.' : 'Failed to add strategy.';
              const message = error.message ? error.message : failedMessage;
              try {
                this.toastService.pop(TOAST_TYPE.error, message);
              } catch (e) {
                this.toastService.pop(TOAST_TYPE.error, message);
              }
            }
          });
      }
    } else if (!this.newStrategy.strategyId){
      this.toastService.pop(TOAST_TYPE.error, 'Please select Tax strategy');
    } else if (!this.newStrategy.clientId){
      this.toastService.pop(TOAST_TYPE.error, 'Please select Payor');
    } else if (!this.newStrategy.sinceYear){
      this.toastService.pop(TOAST_TYPE.error, 'Please select Start Year');
    }
  }

  showActualColumnForStrategies() {
    if (this.showActualColumn) {
      this.columns.splice(7, 0, {name: 'actualAmount', title: 'Actual Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Actual Amount that produced tax savings - determined after implementation. For review with the client.'});
    } else {
      this.showDollarChangeColumn = false;
      this.showPercentageChangeColumn = false;
      this.columns = [
        {name: 'strategyName', title: 'Strategy', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: 'Click strategy name for details'},
        {name: 'strategyType', title: 'Category', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
        {name: 'clientName', title: 'Payor', type: 'badge-input-search', 'status-col': true, classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
        {name: 'relatedPartyType', title: 'Type', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'This can be potential or existing entity types.'},
        {name: 'associated', title: 'Fed Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
        {name: 'stateAssociated', title: 'State Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
        {name: 'amount', title: 'Plan Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Before tax amount of the tax deduction or credit.'},
        {name: 'investedAmount', title: 'Strategy Investment Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: false, format: '$0,0', skipTab: true, headerColumnDesc: ''},
        {name: 'roiAmount', title: 'Fed Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Plan amount multiplied by the associated rate. This field can be overridden as needed.'},
        {name: 'stateRoiAmount', title: 'State Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: ''},
        {name: 'sinceYear', title: 'Begin', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'First tax year you are applying strategy to.'},
        {name: 'toYear', title: 'End', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'If the strategy is not indefinite, this is the last tax year it will apply to.'},
        {name: 'goalDate', title: 'Create Task Date', type: 'date', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, allowPastDate: true, initAlways: true, headerColumnDesc: 'The date you are expecting to implement a given strategy. This field is required to create a associated task.'}];
    }
    this.getClientTaxPlanWithNewData();
    this.buildTableData(this.clientTaxPlan.strategies || []);
  }

  showDollarChangeColumnForStrategies() {
    if (this.showDollarChangeColumn) {
      this.columns.splice(8, 0, {name: 'dollarDifference', title: '$ Change', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: 'Difference between Plan Amount and Actual. For review with the client.'});
    } else {
      this.columns.splice(8, 1);
    }
    this.buildTableData(this.clientTaxPlan.strategies || []);
  }

  showPercentageChangeColumnForStrategies() {
    if (this.showDollarChangeColumn) {
      if (this.showPercentageChangeColumn) {
        this.columns.splice(9, 0, {name: 'percentageDifference', title: '% Change', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: '% difference between Plan Amount and Actual. For review with the client.'});
      } else {
        this.columns.splice(9, 1);
      }
    } else if (this.showPercentageChangeColumn) {
      this.columns.splice(8, 0, {name: 'percentageDifference', title: '% Change', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: '% difference between Plan Amount and Actual. For review with the client.'});
    } else {
      this.columns.splice(8, 1);
    }
    this.buildTableData(this.clientTaxPlan.strategies || []);
  }

  duplicateStrategy(rowData) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.duplicatePlanStrategy(this.org, this.user.id, this.taxStrategyId, rowData.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (response && response.message) {
          this.toastService.pop(TOAST_TYPE.success, response.message);
        } else {
          this.toastService.pop(TOAST_TYPE.success, 'Strategy duplicated successfully');
        }
        this.onStrategyAction.emit();
        this.getClientTaxPlan();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          const message = error.message ? error.message : 'Failed to duplicate a strategy';
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (err) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to duplicate a strategy');
        }
      });
  }

  openFormulaCalculator(tempCustomRate?, index?) {
    if (tempCustomRate) {
      this.tempCustomRateObject = tempCustomRate;
    }
    if (index != -1) {
      this.indexOfTempCustomRateObject = index;
    }
    this.reveal.fromulaCalculator = true;
    this.isMinimized = true;
    this.reveal.addStrategy = false;
  }

  refreshTableData(){
    this.tableData = {...this.tableData};
  }

  triggerCloseAddCustomRateInStrategyPage(rate) {
    this.defaultStrategyId = rate.id;
    this.newStrategy.associatedWith = rate.id;
    this.calculateResultAmount(this.newStrategy);
    this.newCustomRate = {
      id: '',
      name: '',
      rate: 0,
      formula: {
        displayValue: '',
        actualValue: '',
        displayValuesArray: [],
        actualValuesArray: []
      }
    };
    this.showAddCustomRateInPopup = false;
    if (this.isMinimized) {
      this.isMinimized = false;
      this.reveal.addStrategy = true;
    }
  }

  handleSelect(event): void {
    const base = this;
    if (typeof event === 'boolean') {
      this.selectedTableRows = [];
      this.updateDashboardTable(event);
    } else {
      this.handleRowSelection(event);
    }
  }

  handleRowSelection(obj): void {
    const base = this;
    if (obj) {
      const idx = _.findIndex(base.selectedTableRows, { id: obj.id });
      if (idx === -1) {
        base.selectedTableRows.push(obj);
        if (base.bulkSelectAll) {
          base.bulkSelectCount += 1;
          base.checkAllSelected();
          base.checkforReselect(obj);
        }
      } else {
        base.selectedTableRows.splice(idx, 1);
        if (base.bulkSelectAll) {
          base.bulkUnselected.push(obj);
          jQuery('input.global-checkbox').prop('checked', false);
          base.bulkSelectCount -= 1;
        }
        if (base.selectedTableRows.length === 0) {
          base.resetBulkSelected();
        }
      }
    }
  }

  resetBulkSelected(): void {
    this.bulkSelectAll = false;
    this.bulkSelectCount = '';
    this.bulkUnselected = [];
  }

  checkAllSelected(): void {
    const markAllCount = this.getSelectAllCount();
    if (markAllCount && markAllCount === this.bulkSelectCount) {
      jQuery('input.global-checkbox').prop('checked', true);
    }
  }

  checkforReselect(data): void {
    const reselectIndex = _.findIndex(this.bulkUnselected, { id: data.id });
    if (reselectIndex !== -1) {
      this.bulkUnselected.splice(reselectIndex, 1);
    }
  }

  updateDashboardTable(state): void {
    if (state) {
      this.bulkUnselected = [];
      this.selectedTableRows = [];
      this.bulkSelectAll = true;
      this.getSelectAllCount();
      const data = _.cloneDeep(this.tableData.rows);
      data.splice(this.tableData.rows.length - 1, 1);
      this.handleRowSelect(data, state);
    } else {
      this.resetBulkSelected();
      this.handleRowSelect([], state);
    }
  }

  getSelectAllCount(): any {
    this.bulkSelectCount = this.strategiesCount;
  }

  handleRowSelect(selectedRows, state): void {
    const base = this;
    if (this.planStrategiesTable && this.planStrategiesTable.id) {
      const selectedTableId = this.planStrategiesTable.id;
      jQuery('#' + selectedTableId)
        .find('tbody tr input.checkbox')
        .each(function (idx, cbox) {
          const id = jQuery(this).closest('tr').attr('id');
          const isUnSelected = _.find(base.bulkUnselected, { id });
          if (!isUnSelected) {
            if (!state) {
              jQuery(cbox).prop('checked', false);
            } else {
              jQuery(cbox).prop('checked', true);
            }
            if (!jQuery(cbox).is(':checked')) {
              _.remove(base.selectedTableRows, { id });
            }
            base.invokeChangeDetection();
          }
        });
      _.each(selectedRows, (doc) => {
        const isUnSelected = _.find(base.bulkUnselected, { id: doc.id });
        if (!isUnSelected) {
          base.selectedTableRows.push(doc);
        }
      });
      this.selectedTableRows = _.uniqBy(this.selectedTableRows, 'id');
    }
  }

  invokeChangeDetection(): void {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  applyAction($event) {
    if ($event.name == 'Copy to Other') {
      this.getClientsList();
    } else if ($event.name == 'Create a Template') {
      this.reveal.createTemplate = true;
      this.selectedStrategiesForTemplate = this.getFormattedSelectedLines();
    } else if ($event.name == 'Delete') {
      if (!this.selectedTableRows.length) {
        this.toastService.pop(TOAST_TYPE.error, 'No rows selected');
        return;
      }
      this.toastService.pop(
        TOAST_TYPE.confirm,
        `Delete ${this.selectedTableRows.length} strategies?`,
        { type: 'strategyBulkDelete', ids: this.getSelectedIds() }
      );
    }
  }

  onClientSelect(client) {
    this.selectedClient = client;
    this.selectedClientId = client.id
    this.getClientPlans(this.selectedClientId);
  }

  onClientPlanSelect(plan) {
    this.selectedPlan = plan;
    this.selectedPlanId = plan.id;
  }

  getClientPlans(clientId, plan?) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getPlansForClient(this.org, this.user.id, clientId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.clientPlans = _.cloneDeep(response);
        if (plan) {
          this.selectedPlan = plan;
          this.selectedPlanId = plan.id;
        }
        this.reveal.copyStrategiesToOtherPlan = true;
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          const message = error.message ? error.message : 'Failed to get plans';
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (err) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get plans');
        }
      });
  }

  getClientsList(clientData?) {
    const obj = {
      fromIndex: -1
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClients(this.org, this.user.id, obj)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.listOfAllClients = this.formatClientsData(response.clients);
        if (clientData) {
          this.selectedClient = clientData;
          this.selectedClientId = clientData.id;
        }
        this.reveal.copyStrategiesToOtherPlan = true;
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get clients list');
      });
  }

  formatClientsData(clients) {
    let data = [];
    if (clients && clients.length > 0) {
      _.each(clients, function(client) {
        let obj = {};
        obj['id'] = client.id;
        obj['name'] = client.firstName + ' ' + client.lastName;
        obj['email'] = client.email;
        data.push(obj);
      });
    }
    return data;
  }

  copyStrategiesToOther() {
    if (!this.selectedClient) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select client');
      return false;
    }
    if (!this.selectedPlan) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select plan');
      return false;
    }
    const data = {
      fromPlanId: this.taxStrategyId,
      toPlanId: this.selectedPlanId,
      toClientId: this.selectedClientId,
      linesToCopy: this.getFormattedSelectedLines()
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.copyStrategiesToOther(this.org, this.user.id, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Strategies Copied successfully');
        this.reveal.copyStrategiesToOtherPlan = false;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          const message = error.message ? error.message : 'Failed to copy strategies';
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (err) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to copy strategies');
        }
      });
  }

  getFormattedSelectedLines() {
    const selectedLines = [];
    _.each(this.selectedTableRows, (row) => {
      const line = _.find(this.clientTaxPlan.strategies, {id: row.id});
      if (line) {
        selectedLines.push(line);
      }
    });
    return selectedLines;
  }

  getSelectedIds() {
    return this.selectedTableRows.map(row => row.id);
  }

  bulkDeleteStrategyLines(strategyIds: string[]) {
    this.loadingService.triggerLoadingEvent(true);
  
    const deleteCalls = strategyIds.map(id =>
      this.taxPlanningService.deleteTaxStrategyLine(this.org, this.user.id, this.taxStrategyId, id)
    );
  
    forkJoin(deleteCalls).subscribe({
      next: () => {
        this.toastService.pop(TOAST_TYPE.success, 'Strategies deleted successfully');
  
        // 🔹 keep whatever logic you already have here
        this.clientTaxPlan.strategies = this.clientTaxPlan.strategies.filter(
          (s: any) => !strategyIds.includes(s.id)
        );
        const hasPositiveActualAmount = this.clientTaxPlan.strategies.some(
          (item: any) => item.actualAmount > 0
        );
        this.showActualAmountColumn(hasPositiveActualAmount);
  
        this.buildTableData(this.clientTaxPlan.strategies || []);

        // 🔹 Refresh the full plan AFTER deletes complete to ensure totals are recalculated
        this.getClientTaxPlanWithNewData((plan) => {
          this.onStrategyAction.emit({
            type: 'strategy-bulk-deleted',
            plan
          });
        });
      },
      error: () => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to delete strategies');
      }
    });
  }

  openCreatePopup(type) {
    if (type == 'Client') {
      this.reveal.addOrEditClient = true;
    } else if (type == 'Plan') {
      if (this.selectedClient) {
        this.reveal.addPlan = true;
        this.reveal.addPlan = true;
      } else {
        this.toastService.pop(TOAST_TYPE.error, 'Please select client');
        return false;
      }
    }
  }

  refreshListOfClients(client) {
    this.reveal.addOrEditClient = false;
    this.getClientsList(client);
  }

  refreshListOfPlans(plan) {
    this.reveal.addPlan = false;
    this.getClientPlans(this.selectedClientId, plan);
  }

  showActualAmountColumn(hasPositiveActualAmount){
    if (hasPositiveActualAmount && !this.showActualColumn) {
      this.showActualColumn = true;
      this.columns.splice(7, 0, {name: 'actualAmount', title: 'Actual Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Actual Amount that produced tax savings - determined after implementation. For review with the client.'});
    }else if (!hasPositiveActualAmount && this.showActualColumn) {
      this.showActualColumn = false;
       const index = this.columns.findIndex(c => c.name === 'actualAmount');
        if (index !== -1) {
          this.columns.splice(index, 1);
        }
    }else if (!hasPositiveActualAmount && !this.showActualColumn) {
      console.log('case 3');
    }
    else if (hasPositiveActualAmount && this.showActualColumn){
       const actualAmountExists = this.columns.some(col => col.name === 'actualAmount');
      if (!actualAmountExists) {
        this.columns.splice(7, 0, {
          name: 'actualAmount',
          title: 'Actual Amount',
          type: 'input-currency',
          classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip',
          sortable: true,
          format: '$0,0',
          skipTab: true,
          headerColumnDesc: 'Actual Amount that produced tax savings - determined after implementation. For review with the client.'
        });
      }
    }
    else {
       this.showActualColumn = false;
       const index = this.columns.findIndex(c => c.name === 'actualAmount');
        if (index !== -1) {
          this.columns.splice(index, 1);
        }
    }
  }

  closeGoalDateModal() {
  this.hasGoalDate = false;
  this.modalSelectedDate = '';
  const foundStrategy = this.clientTaxPlan.strategies?.find(x => x.id === this.pendingStrategyLine.id);
  if (foundStrategy) {
  const strategyUpdate = this.tableData.rows?.find(x => x.id === foundStrategy.id);
  strategyUpdate.goalDate = foundStrategy.goalDate;
  }
  this.tableData = { ...this.tableData};
  }

  onKeepAndUpdate() {
    if (!this.modalSelectedDate) return;
    this.pendingStrategyLine.goalDate = this.modalSelectedDate.split('-').slice(1).concat(this.modalSelectedDate.split('-')[0]).join('/');
    this.setRelatedPartyName(this.pendingStrategyLine);
    this.updateStrategyLine(this.pendingStrategyLine);
    this.closeGoalDateModal();
  }

  onDeleteTask() {
  if (!this.pendingStrategyLine) return;
  const lineToDelete = this.pendingStrategyLine;
  this.tasksService.deleteTask(this.org, this.user.id,lineToDelete.taskId)
    .subscribe({
      next: (response) => {
        this.toastService.pop(TOAST_TYPE.success, 'Task deleted successfully');
        lineToDelete.taskId = null;
        lineToDelete.goalDate = '';
        this.setRelatedPartyName(lineToDelete);
        this.updateStrategyLine(lineToDelete);
      },
      error: (error) => {
        this.toastService.pop(TOAST_TYPE.error, 'Failed to delete task');
      }
    });
  this.closeGoalDateModal();
  }

  handleOrderChanged(updatedData: any[]){
    this.reorderedData = updatedData;
    this.isOrderChanged = true;
  }

  applyReorder() {
  if (!this.reorderedData || !this.isOrderChanged) {
    return;
  }
  this.loadingService.triggerLoadingEvent(true);
  const payload = this.reorderedData.filter(item => item && item.strategyId != null).map((item, index) => ({
      id: item.id,
      strategyId: item.strategyId,
      sequenceNumber: index + 1
    }));

  this.taxPlanningService.reorderPlanStrategies(this.org, this.user.id, this.taxStrategyId, payload).subscribe({
    next: (response) => {
      this.loadingService.triggerLoadingEvent(false);
      this.getClientTaxPlanWithNewData();
      this.isReorderMode = false;
      this.reorderedData = null;
      this.isOrderChanged = false;
    },
    error: () => {
      this.isReorderMode = false;
      this.reorderedData = null;
      this.isOrderChanged = false;
      this.loadingService.triggerLoadingEvent(false);
      console.error('Failed to update sequence');
    }
  });
}

  enableReorderMode() {
    this.isReorderMode = true;
    if (!this.strategySort || !Object.keys(this.strategySort).length) {
      const data = this.clientTaxPlan.strategies || [];
      this.buildTableData(data);
    }else{
     this.getClientTaxPlanWithNewData();
    }
    
    
  }

  cancelReorderMode() {
    this.isReorderMode = false;
    this.isOrderChanged = false;
    this.reorderedData = null;
    const data = this.clientTaxPlan.strategies || [];
    this.buildTableData(data);
  }

  restoreCheckboxStates(): void {
    const base = this;
    if (!this.planStrategiesTable || !this.planStrategiesTable.id) {
      return;
    }

    // Get all non-total rows from the table
    const allDataRows = this.tableData.rows.filter(row => row.id && !row.isTotalRow);
    const totalDataRows = allDataRows.length;

    // If no rows were previously selected, ensure checkboxes are unchecked and dropdown is hidden
    if (!this.selectedTableRows || this.selectedTableRows.length === 0) {
      const selectedTableId = this.planStrategiesTable.id;
      jQuery('#' + selectedTableId)
        .find('tbody tr input.checkbox')
        .each(function (idx, cbox) {
          jQuery(cbox).prop('checked', false);
        });
      // Uncheck header checkbox
      jQuery('#' + selectedTableId).find('thead tr input.global-checkbox').prop('checked', false);
      this.resetBulkSelected();
      return;
    }

    // Filter selectedTableRows to only include rows that still exist in the new table data
    const validSelectedIds = this.selectedTableRows
      .map(row => row.id)
      .filter(id => {
        return this.tableData.rows && this.tableData.rows.some(r => r.id === id && !r.isTotalRow);
      });

    // Update selectedTableRows with new row objects from the rebuilt table
    this.selectedTableRows = this.tableData.rows
      .filter(row => validSelectedIds.includes(row.id) && !row.isTotalRow);

    // Restore checkbox states in the DOM
    const selectedTableId = this.planStrategiesTable.id;
    const checkboxElements = jQuery('#' + selectedTableId).find('tbody tr input.checkbox');
    
    // Only proceed if checkboxes exist in the DOM
    if (checkboxElements.length > 0) {
      checkboxElements.each(function (idx, cbox) {
        const id = jQuery(this).closest('tr').attr('id');
        const isSelected = validSelectedIds.includes(id);
        jQuery(cbox).prop('checked', isSelected);
      });
    }

    // Filter bulkUnselected to only include rows that still exist
    const validBulkUnselectedIds = this.bulkUnselected.filter(unselectedId => 
      this.tableData.rows.some(r => r.id === unselectedId && !r.isTotalRow)
    );
    this.bulkUnselected = validBulkUnselectedIds;

    // Check if "select all" was active before refresh
    if (this.bulkSelectAll) {
      // With "select all" active, all rows should be selected except those in bulkUnselected
      const expectedSelectedCount = totalDataRows - validBulkUnselectedIds.length;
      const allExpectedRowsSelected = totalDataRows > 0 && validSelectedIds.length === expectedSelectedCount;
      
      if (allExpectedRowsSelected) {
        // Restore "select all" state - header checkbox should be checked
        jQuery('#' + selectedTableId).find('thead tr input.global-checkbox').prop('checked', true);
        this.bulkSelectCount = this.strategiesCount;
      } else {
        // Not all expected rows are selected, uncheck header checkbox
        jQuery('#' + selectedTableId).find('thead tr input.global-checkbox').prop('checked', false);
        // If we had bulk select all but selection doesn't match, reset the state
        this.bulkSelectAll = false;
        this.bulkSelectCount = '';
        this.bulkUnselected = [];
      }
    } else {
      // "Select all" was not active, check if all rows happen to be selected anyway
      const allRowsSelected = totalDataRows > 0 && validSelectedIds.length === totalDataRows;
      // Uncheck header checkbox (since bulkSelectAll is false)
      jQuery('#' + selectedTableId).find('thead tr input.global-checkbox').prop('checked', false);
    }

    // Clear selectedTableRows if no valid selections remain
    if (this.selectedTableRows.length === 0) {
      this.resetBulkSelected();
      jQuery('#' + selectedTableId).find('thead tr input.global-checkbox').prop('checked', false);
    }
  }


  //Helper funtion to solve the invested amount properly 
  parseInvestmentFormula(formula: any): number {
  if (!formula) {
    return 0;
  }
  // convert to string
  let value = formula.toString().trim();

  // case 1 → percentage (10%)
  if (value.includes('%')) {
    return Number(value.replace('%', '')) / 100;
  }
  // case 2 → division (10/100)
  if (value.includes('/')) {
    try {
      return evaluate(value);
    } catch {
      return 0;
    }
  }

  // case 3 → decimal already (0.10)
  const num = Number(value);
  if (!isNaN(num)) {
    return num;
  }

  return 0;
}

calculateInvestmentAmount(strategy: any) {
  strategy.investmentOverriden = true;
  
  if (!strategy.investedAmount || !strategy.investmentFormula) {
    return;
  }

  const investedAmount = this.numeralService.getNumberValue(strategy.investedAmount);
  const multiplier = this.parseInvestmentFormula(strategy.investmentFormula);
  const calculatedAmount = investedAmount * multiplier;

  strategy.amount = Math.ceil(calculatedAmount);

  this.calculateResultAmount(strategy, true);
}

 getStateAssociated(stateAssociate) {
    let stateAssociated: any;
    _.each(this.allStateAssociatedData, (obj) => {
      if ((stateAssociate === 'State Individual Rate' || stateAssociate === 'Individual State Rate') && obj.name.includes('Ind State Rate')) {
        stateAssociated = obj;
      } else if ((stateAssociate === 'State Corporate Rate' || stateAssociate === 'Corporate State Rate') && obj.name.includes('Corp State Rate')) {
        stateAssociated = obj.name;
      }  else if (obj.name === 'N/A' && !stateAssociated) {
        stateAssociated = obj;
      }
    });
    return stateAssociated;
  }

}
